export function drosTopicList(targetElem: HTMLElement) {
    let children = targetElem.children;
    let width = targetElem.clientWidth;
    let widthString = width + 'px';
    let halfWidth = Math.floor(width / 2);
    let halfWidthString = halfWidth + 'px';
    let quadWidth = Math.floor(width / 4);
    let quadWidthString = quadWidth + 'px';

    for (let i = 0; i < children.length; ++i) {
        let child = children[i] as HTMLElement;
        child.style.display = 'inline-block'
        let { width } = child.getBoundingClientRect();
        if (width < quadWidth) {
            child.style.width = quadWidthString;
        } else if (width < halfWidth) {
            child.style.width = halfWidthString;
        } else {
            child.style.width = widthString;
        }
    }
}
